// extracted by mini-css-extract-plugin
export default {"container":"InnerPageContent_container__95hIt"};